import MobileTopHeaderNav from '@/components/atoms/headers/mobileTopHeaderNav'
import MobilePlatformMenu from '@/components/molecules/navigation/mobilePlatformMenu'
// import SEO from '@/components/seo'
import GlobalCtx, { IGlobalCtx } from '@/context/global'
import { platformMenunData } from '@/context/navigation_n_menu_data'
import posthog from 'posthog-js'

import * as React from 'react'
import { useEffect, useState } from 'react'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'
import { IGarage } from 'shared-interfaces'
import PageTopSectionDesktop from '../../molecules/pageTopSection.tsx/pageTopSectionDesktop'

interface Props {
    children?: React.ReactNode
}

const GaragePageLayout: React.FunctionComponent<Props> = (props) => {
    const { children } = props
    const globalCtx: IGlobalCtx = React.useContext(GlobalCtx)

    //making sure that children of TouchScrollable are mounted, otherwise throws error
    const ref: any = React.useRef()
    const [mounted, setMounted] = useState(false)
    useEffect(() => {
        ref.current = document.getElementById('mobile_platform_menu')
        setTimeout(() => setMounted(true), 50)
    }, [])
    let garage: IGarage | null | undefined = globalCtx.garage

    let onCrossClick = () => {
        if (globalCtx.isPlatformMenuOpen) {
            globalCtx.togglePlatformMenu(false)
        } else {
            globalCtx.togglePlatformMenu(true)
            posthog.capture('public viewer opens platform menu from mobile')
        }
    }

    return (
        <>
            {globalCtx.isPlatformMenuOpen && <ScrollLock />}
            {garage && (
                <>
                    <PageTopSectionDesktop />
                    <MobileTopHeaderNav
                        garageid={garage && garage.id ? garage.id : ''}
                        isOpen={globalCtx.isPlatformMenuOpen}
                        onCrossClick={onCrossClick}
                    />
                    {mounted && (
                        <TouchScrollable>
                            <div id="mobile_platform_menu">
                                <MobilePlatformMenu
                                    isOpen={globalCtx.isPlatformMenuOpen}
                                    menu_data={platformMenunData}
                                    onCrossClick={onCrossClick}
                                />
                            </div>
                        </TouchScrollable>
                    )}

                    {children}
                </>
            )}
        </>
    )
}

export default GaragePageLayout
